/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

export default class Navigation {
  constructor(config) {
    // 変数の設定
    // ---------------------------------------------------
    this.config = config;
    this.humIdName = this.config.humIdName || "hum_toggle";
    this.navIdName = this.config.navIdName || "site_navigation";
    this.humElm = document.getElementById(`${this.humIdName}`);
    this.navElm = document.getElementById(`${this.navIdName}`);
    if (!this.humElm || !this.navElm) {
      console.warn(
        "[Navigation.js] ナビゲーションの要素もしくは、ハンバーガーメニューのトグルボタンの要素が設定されていません。"
      );
      return;
    }
    this.linkElm = this.navElm.querySelectorAll(`a`);

    this.html = document.documentElement;
    this.body = document.body;
    this.pcSize = false;
    this.timeoutId;

    // 初期処理
    // ---------------------------------------------------
    const menu = this.navElm.getElementsByTagName("ul")[0];
    if (!menu.classList.contains("nav-menu")) {
      menu.classList.add("nav-menu");
    }

    // イベントリスナー系の処理
    // ---------------------------------------------------
    this.humElm.addEventListener("click", () => {
      this.humElm.classList.toggle("active");
      this.navElm.classList.toggle("active");
      this.html.classList.toggle("hum_active");
      this.body.classList.toggle("hum_active");
    });

    window.addEventListener("DOMContentLoaded", () => this.initFun(), false);
    window.addEventListener("resize", () => this.resize(), false);
  }

  widWatch() {
    const w = window.innerWidth;
    this.pcSize = w >= 1025 ? true : false;
    return;
  }

  linkClick() {
    this.linkElm.forEach((elm, i) => {
      elm.addEventListener("click", () => this.closeAction());
    });
  }
  closeAction() {
    this.humElm.classList.remove("active");
    this.navElm.classList.remove("active");
    this.html.classList.remove("hum_active");
    this.body.classList.remove("hum_active");
  }
  initFun() {
    this.widWatch();
    this.linkClick();
  }
  resize() {
    this.widWatch();
    this.body.setAttribute("id", "preload");
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.body.removeAttribute("id", "preload");
    }, 500);
  }
}
